import { render, staticRenderFns } from "./SlaughterForecastContent.vue?vue&type=template&id=768358f4"
import script from "./SlaughterForecastContent.vue?vue&type=script&lang=js"
export * from "./SlaughterForecastContent.vue?vue&type=script&lang=js"
import style0 from "./SlaughterForecastContent.vue?vue&type=style&index=0&id=768358f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports